import { autoinject, customElement } from 'aurelia-framework';
import { NavModel } from 'aurelia-router';
import { bindable } from 'aurelia-typed-observable-plugin';
import { NavItemEventArgs } from 'model/navigation';

@autoinject
@customElement('bs-nav-items')
export class NavItems {
  @bindable heading: string = null;
  @bindable headingIcon: string = null;
  @bindable navigation: NavModel[] = [];
  @bindable clicked = (args: NavItemEventArgs) => true;

  linkClicked(nav: NavModel) {
    return nav.settings.clicked ? nav.settings.clicked() : this.clicked && this.clicked({ nav: nav });
  }
}
